import React, {useEffect, useState} from 'react'

const ProcessingTime = ({processingAt, hovering, errorMessage}) => {
    const [formattedTime, setFormattedTime] = useState('')

    const calculateTime = () => {
        if(!!errorMessage) return errorMessage

        const startTime = new Date(processingAt)
        const endTime = new Date()
        const processingTime = endTime - startTime
        const hours = Math.floor(processingTime / (1000 * 60 * 60))
        const minutes = Math.floor((processingTime % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((processingTime % (1000 * 60)) / 1000)

        return `${!!hours ? String(hours).padStart(2, '0') + 'h' : ''} ${!!minutes ? String(minutes).padStart(2, '0') + 'm' : ''} ${!!seconds ? String(seconds).padStart(2, '0') + 's' : ''}`
    }

    useEffect(() => {
        if (hovering) {
            const newTime = calculateTime()
            setFormattedTime(newTime)
        }
    }, [hovering, processingAt])

    return formattedTime
}

export default ProcessingTime